module.exports = __webpack_public_path__ + "img/dessert.1da41d08.jpg";